import styles from './style.postcss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PageCard, Button, Checkbox } from 'omni-common-ui';
import CardActionIcons from 'components/CardActionIcons';
import ContentItem from '.././ContentItem';

class GroupHomeworkCard extends Component {
  constructor(props) {
    super();
    this.state = {
      disabledSaveButton: true,
    };
    this._setGroupHomeworkItems(props);
    this._editIconClick = this._editIconClick.bind(this);
    this._onSaveClick = this._onSaveClick.bind(this);
    this._onDiscardClick = this._onDiscardClick.bind(this);
  }

  componentWillReceiveProps(props) {
    if (props.homeworkTemplate !== this.props.homeworkTemplate ||
        (props.homeworkContent !== this.props.homeworkContent && ! props.editMode)) {
      this._setGroupHomeworkItems(props);
    }
  }

  _editIconClick() {
    this.props.onEditClick();
    this.setState({
      disabledSaveButton: true,
    });
    this._setGroupHomeworkItems(this.props);
  }

  _onDiscardClick() {
    this.props.onDiscardClick();
    this._setGroupHomeworkItems(this.props);
  }

  _setGroupHomeworkItems(props) {
    const { homeworkContent, isNewStatus } = props;
    let homeworkTemplate = props.homeworkTemplate;
    if (! homeworkTemplate) {
      return;
    }
    if (isNewStatus) {
      homeworkTemplate = this._setHomeworkContentAssigned(homeworkTemplate, true);
    }
    this.setState({ editedGroupHomeworkItems: homeworkTemplate.mergeDeep(
      this._setHomeworkContentAssigned(homeworkContent, false)) });
  }

  _setHomeworkContentAssigned(homeworkContent, isFromTemplate) {
    return homeworkContent && homeworkContent.map((homwork) =>
      homwork.update('contentItems', (contentItems) =>
        contentItems.map((contentItem) => {
          if (! isFromTemplate || ! contentItem.isDeleted) {
            return contentItem.set('isAssigned', true);
          }

          return contentItem;
        })));
  }

  _onSaveClick() {
    const toSaveHomeworkItems = this.state.editedGroupHomeworkItems.map((homwork) =>
      homwork.update('contentItems', (contentItems) =>
        contentItems.filter((item) => !! item.isAssigned)));
    this.props.onSaveClick(toSaveHomeworkItems);
  }

  _handleCheckBoxChecked(item, unitId, lessonNumber, checkBoxStatus) {
    this.setState({ disabledSaveButton: false });
    const { editedGroupHomeworkItems } = this.state;
    let newItem = item;
    newItem = item.set('isAssigned', checkBoxStatus);
    const newEditedGroupHomeworkItems =
      editedGroupHomeworkItems.update(`${unitId}-${lessonNumber}`, (lesson) =>
        lesson.set('contentItems',
          lesson.contentItems.set(newItem.homeworkContentId, newItem)));
    this.setState({
      editedGroupHomeworkItems: newEditedGroupHomeworkItems,
    });
    this.props.onNowSaveable(newEditedGroupHomeworkItems);
  }

  _renderViewModeContentItem(item, unitId, lessonNumber) {
    return <ContentItem key={`${unitId}-${lessonNumber}-${item.name}`}
        className={styles.GroupHomeworkCard_item}
        homeworkType={item.homeworkType}
        boardTitle={item.name}
        boardValue={item.description} />;
  }

  _renderEditModeContentItem(item, unitId, lessonNumber) {
    const checkBoxCheckedHandler = this._handleCheckBoxChecked
        .bind(this, item, unitId, lessonNumber);
    const uniqueId = `${unitId}-${lessonNumber}-${item.homeworkContentId}`;
    return <ContentItem key={uniqueId}
        className={styles.GroupHomeworkCard_item}
        homeworkType={item.homeworkType}
        boardTitle={item.name}
        boardValue={<label htmlFor={uniqueId}>
          <Checkbox id={uniqueId}
              checked={item.isAssigned}
              onChange={checkBoxCheckedHandler} />
          <span className={styles.GroupHomeworkCard_item_content}>
            {item.description}
          </span>
        </label>} />;
  }

  render() {
    const { canEdit, editMode, homeworkContent, homeworkTemplate, isNewStatus } = this.props;
    const { editedGroupHomeworkItems, disabledSaveButton } = this.state;
    const validTemplate = ! homeworkTemplate ? homeworkTemplate : homeworkTemplate.map((homwork) =>
    homwork.update('contentItems', (contentItems) =>
      contentItems.filter((contentItem) => ! contentItem.isDeleted)));
    const viewHomework = isNewStatus ? validTemplate : homeworkContent;
    const groupHomework = editMode ? editedGroupHomeworkItems : viewHomework;
    if (! groupHomework) return null;
    return <PageCard>
      <PageCard.Heading text="Group Practice" stackMode="horizontal">
        <CardActionIcons onEditClick={this._editIconClick}
            hideEditIcon={! canEdit || editMode}
            hideDeleteIcon />
      </PageCard.Heading>
      <PageCard.Content className={styles.GroupHomeworkCard}>
        {
          groupHomework.map(
            ({ lessonNumber, unitOrderingSequence, unitId, contentItems }) => [
              <h4 key={`${unitOrderingSequence}-${lessonNumber}`}>
              Unit {unitOrderingSequence}, Lesson {lessonNumber}
              </h4>,
            ].concat(
            contentItems
              .map((item) =>  // eslint-disable-line no-confusing-arrow
                editMode ?
                  this._renderEditModeContentItem(item, unitId, lessonNumber) :
                  this._renderViewModeContentItem(item, unitId, lessonNumber))))
        }
        {
          editMode ?
            <div className={styles.GroupHomeworkCard_buttons}>
              <Button.Container align="right">
                <Button type={Button.Type.primary}
                    onClick={this._onSaveClick}
                    disabled={disabledSaveButton}>
                  Save
                </Button>
                <Button type={Button.Type.default}
                    onClick={this._onDiscardClick}>
                  Discard
                </Button>
              </Button.Container>
            </div> :
            null
        }
      </PageCard.Content>
    </PageCard>;
  }
}

GroupHomeworkCard.propTypes = {
  homeworkContent: PropTypes.shape({
    map: PropTypes.func,
    update: PropTypes.func,
  }),
  homeworkTemplate: PropTypes.shape({
    map: PropTypes.func,
    update: PropTypes.func,
  }).isRequired,
  isNewStatus: PropTypes.bool,
  editMode: PropTypes.bool,
  canEdit: PropTypes.bool,
  onEditClick: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func.isRequired,
  onDiscardClick: PropTypes.func.isRequired,
  onNowSaveable: PropTypes.func.isRequired,
};

export default GroupHomeworkCard;



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/Assignments/GroupHomeworkCard/index.jsx